import styled from "styled-components";

const NoBold = styled.span`
  font-weight: 300;
`;

export default NoBold;
